import type { ReactNode } from "react";
import clsx from "clsx";

const AlertBanner = ({
  text,
  type = "warning",
  className,
}: {
  text: string;
  type?: "disabled" | "warning";
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        className,
        "flex justify-center rounded-full px-5 py-0.5 sm:py-0.5",
        {
          "bg-orange": type === "warning",
          "bg-gray-light": type === "disabled",
        },
      )}
    >
      <div
        className={clsx("text-center text-sm font-bold uppercase", {
          "text-orange-dark": type === "warning",
          "text-gray": type === "disabled",
        })}
      >
        {text}
      </div>
    </div>
  );
};

export default AlertBanner;
